import React, { useState } from "react";
import {
  Box,
  Button,
  Center,
  ChakraProvider,
  Divider,
  DrawerFooter,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Upload } from "react-feather";
import NumberInput from "../../../atoms/NumberInput";
import CustomFormLabel from "../../../atoms/CustomFormLabel";
import { Controller, useForm } from "react-hook-form";
import { BoxWrapper } from "./TruckDrawer";

const TruckInfo = ({
  activeStep,
  handleChange,
  isEditMode,
  initialValue: {
    truck,
    owner,
    driver, aggregator,category
  },
  isValid,
  handleAddSubmit
}) => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    handleFormChange(event);
  };

  const handleFileDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    setSelectedFile(file);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleFormChange = (e) => {
    handleChange(e, "truck");
    console.log(e.target.value);
  };

  const handleOwnerFormChange = (e) => {
    handleChange(e, "owner");
  };

  const handleCategoryFormChange = (e) => {
    handleChange(e, "category");
  };

  const handleAggregatorFormChange = (e) => {
    handleChange(e, "aggregator");
  };

  const handleDriverFormChange = (e) => {
    handleChange(e, "driver");
  };


  const handleRadioButton = (e, name) => {
    handleFormChange({ target: { name, value: e } });
  };
  return (
    <Box display={activeStep > 0 ? "none" : "block"}>
      <ChakraProvider>
        <Text>
          Truck information
        </Text>
        <BoxWrapper>
          {/* <Flex justify="space-between" gap={3}> */}
            <FormControl isRequired width={"23%"}>
              <FormLabel color={"#191b1c"}>Truck No.</FormLabel>
              <Input
                name="truckNumber"
                type="text"
                onChange={handleFormChange}
                value={truck.truckNumber}
                disabled={isEditMode}
              />
            </FormControl>
          {/* </Flex> */}
        </BoxWrapper>
        <Text>
          Driver information
        </Text>
        <BoxWrapper>
          <Flex justify="space-between" gap={3}>
            <FormControl isRequired>
              <FormLabel color={"#191b1c"}>First Name</FormLabel>
              <Input
                name="firstName"
                type="text"
                onChange={handleDriverFormChange}
                value={driver.firstName}
                disabled={isEditMode}
                required
              />
            </FormControl>
            <FormControl>
              <FormLabel color={"#191b1c"}>Middle Name</FormLabel>
              <Input
                name="middleName"
                type="text"
                onChange={handleDriverFormChange}
                value={driver.middleName}
                disabled={isEditMode}
              />
            </FormControl>
            <FormControl>
              <FormLabel color={"#191b1c"}>Last Name</FormLabel>
              <Input
                name="lastName"
                type="text"
                onChange={handleDriverFormChange}
                value={driver.lastName}
                disabled={isEditMode}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel color={"#191b1c"}>Contact No.</FormLabel>
              <Input
                name="contactNo"
                type="number"
                onChange={handleDriverFormChange}
                value={driver.contactNo}
                disabled={isEditMode}
              />
            </FormControl>
          </Flex>
        </BoxWrapper>
        <Text>
          Owner information
        </Text>
        <BoxWrapper>
          <Flex justify="space-between" gap={3} width={"23%"}>
            <FormControl>
              <FormLabel color="gray.600">Category</FormLabel>
              <Select
                name="truckType"
                onChange={handleFormChange}
                value={truck.truckType}
              >
                <option value="owner">Owner</option>
                <option value="aggregator">Aggregator</option>
              </Select>
            </FormControl>
          </Flex>
          <Flex justify="space-between" gap={3}>
            <FormControl isRequired>
              <FormLabel color={"#191b1c"}>First Name</FormLabel>
              <Input
                name="firstName"
                type="text"
                onChange={handleCategoryFormChange}
                value={category.firstName}
                disabled={isEditMode}
                required
              />
            </FormControl>
            <FormControl >
              <FormLabel color={"#191b1c"}>Middle Name</FormLabel>
              <Input
                name="middleName"
                type="text"
                onChange={handleCategoryFormChange}
                value={category.middleName}
                disabled={isEditMode}
              />
            </FormControl>
            <FormControl>
              <FormLabel color={"#191b1c"}>Last Name</FormLabel>
              <Input
                name="lastName"
                type="text"
                onChange={handleCategoryFormChange}
                value={category.lastName}
                disabled={isEditMode}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel color={"#191b1c"}>Contact No.</FormLabel>
              <Input
                name="contactNo"
                type="number"
                onChange={handleCategoryFormChange}
                value={category.contactNo}
                disabled={isEditMode}
              />
            </FormControl>
          </Flex>
        </BoxWrapper>
        {/* <Flex justify="space-between" gap={3}>
            <FormControl>
              <FormLabel color={"#191b1c"}>Maker Description</FormLabel>
              <Input
                name="makerDescription"
                type="text"
                onChange={handleFormChange}
                value={makerDescription}
              />
            </FormControl>
            <FormControl>
              <FormLabel color={"#191b1c"}>Maker Model</FormLabel>
              <Input
                name="makerModel"
                type="text"
                onChange={handleFormChange}
                value={makerModel}
              />
            </FormControl>
            <FormControl>
              <FormLabel color={"#191b1c"}>Engine No.</FormLabel>
              <Input
                name="engineNo"
                type="text"
                onChange={handleFormChange}
                value={engineNo}
              />
            </FormControl>
          </Flex>
          <Flex justify="space-between" gap={3}>
            <FormControl>
              <FormLabel color={"#191b1c"}>Chassis No.</FormLabel>
              <Input
                name="chasisNo"
                type="text"
                onChange={handleFormChange}
                value={chasisNo}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel color={"#191b1c"}>Unladen Weight (ULW) (KG)</FormLabel>
              <NumberInput
                name="unlaidenWeight"
                onChange={handleFormChange}
                value={unlaidenWeight}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel color={"#191b1c"}>Laden Weight (KG)</FormLabel>
              <NumberInput
                name="laidenWeight"
                onChange={handleFormChange}
                value={laidenWeight}
              />
            </FormControl>
          </Flex>
          <Flex justify="space-between" gap={3}>
            <FormControl>
              <FormLabel color={"#191b1c"}>Cubic Capacity (cc)</FormLabel>
              <NumberInput
                name="cubicCapacity"
                onChange={handleFormChange}
                value={cubicCapacity}
              />
            </FormControl>
            <FormControl>
              <FormLabel color={"#191b1c"}>Allowed wt</FormLabel>
              <NumberInput name="allowedWeight" type="number" />
            </FormControl>
            <FormControl isRequired>
              <FormLabel color={"#191b1c"}>RC Registration at</FormLabel>
              <Input
                name="rcRegistrationAt"
                type="text"
                onChange={handleFormChange}
                value={rcRegistrationAt}
              />
            </FormControl>
          </Flex>
          <Flex justify="space-between" gap={3}>
            <FormControl isRequired>
              <FormLabel color={"#191b1c"}>Truck Hypothecated</FormLabel>
              <RadioGroup
                defaultValue={(truckHypothecated || "").toString() || "false"}
                name="truckHypothecated"
                onChange={(e) => handleRadioButton(e, "truckHypothecated")}
              >
                <Stack direction="row">
                  <Radio value="true">Yes</Radio>
                  <Radio value="false">No</Radio>
                </Stack>
              </RadioGroup>
            </FormControl>
            <FormControl isRequired>
              <FormLabel color={"#191b1c"}>RC Status</FormLabel>
              <RadioGroup
                defaultValue={rcStatus || ""}
                name="rcStatus"
                onChange={(e) => handleRadioButton(e, "rcStatus")}
              >
                <Stack direction="row">
                  <Radio value="active">Active</Radio>
                  <Radio value="Inactive">Inactive</Radio>
                </Stack>
              </RadioGroup>
            </FormControl>
            <FormControl>
              <FormLabel color={"#191b1c"}>Hypothecated To</FormLabel>
              <Input
                name="hypothecatedTo"
                type="text"
                onChange={handleFormChange}
                value={hypothecatedTo}
              />
            </FormControl>
          </Flex> */}
        {/* <FormControl>
            <FormLabel>Truck Documents</FormLabel>
            <Center
              w="full"
              h="120px"
              borderWidth="1px"
              borderStyle="dashed"
              borderColor="blue.200"
              borderRadius="md"
              position="relative"
              onDrop={handleFileDrop}
              onDragOver={handleDragOver}
            >
              {selectedFile ? (
                <Text>{selectedFile.name}</Text>
              ) : (
                <>
                  <input
                    type="file"
                    id="truckDocuments"
                    name="truckDocuments"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    disabled
                  />
                  <label htmlFor="truckDocuments">
                    <Flex alignItems={"center"}>
                      <Upload color="blue" size={30} />
                      <Box ml={2}>
                        <Text fontSize="xl" color={"blue"}>
                          Upload Document
                        </Text>
                        <Text>Select from system and drag and drop here</Text>
                      </Box>
                    </Flex>
                  </label>
                </>
              )}
            </Center>
          </FormControl> */}
        <DrawerFooter>
          <Button
            type="submit"
            colorScheme="blue"
            variant="solid"
            width={"200px"}
            mb={4}
            position={"absolute"}
            bottom={5}
            right={5}
            isDisabled={isValid}
            onClick={handleAddSubmit}
          >
            {isEditMode ? "Update Truck" : "Add Truck"}
          </Button>
        </DrawerFooter>
      </ChakraProvider>
    </Box>
  );
};

export default TruckInfo;